import { AxiosResponse } from "axios";
import useSWR, { KeyedMutator } from "swr";
import { Prompt } from "@/models/prompt";
import ApiService, { defaultSWROption } from "@/services/api/api.service";
import { PromptSchema } from "./prompt.api.types";
import PromptEndpoints from "./prompt.endpoint";

export class PromptService {
  static getPrompts(workspaceId: string | null = null): {
    data: Prompt[] | undefined;
    error: unknown;
    isLoading: boolean;
    mutate: KeyedMutator<AxiosResponse<PromptSchema[], undefined>>;
  } {
    const url = PromptEndpoints.GET_PROMPTS(workspaceId);

    const fetcher = () =>
      ApiService.fetchData<undefined, PromptSchema[]>({
        url,
        method: "GET",
      });

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, error, isLoading, mutate } = useSWR(
      workspaceId ? url : null,
      fetcher,
      defaultSWROption,
    );

    return {
      data: data?.data.filter(requiredPrompt).map(buildPrompt),
      error,
      isLoading,
      mutate,
    };
  }

  static async update(id: string, content: string): Promise<void> {
    const data = { content };
    await ApiService.fetchData<{ content: string; }, void>({
      url: PromptEndpoints.UPDATE_PROMPT(id),
      method: "PUT",
      data,
    });
  }
}

const requiredPrompt = (prompt: PromptSchema) => {
  return prompt.type === "GENERATE_SHORT_SUMMARY"
    ? prompt.label === "default"
    : prompt.label !== "default";
};

const buildPrompt = (prompt: PromptSchema) => {
  return new Prompt(
    prompt.id,
    prompt.type,
    prompt.label,
    prompt.content.replace(/\\n/g, "\n"),
    prompt.requiredVariables,
  );
};
